import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import { downloadDelayMis } from '../../helpers/delayMisExport';

// Download button for the delay MIS. Lazily enriches the rows with pickup + drop address
// (by AWB) at click time, then generates the xlsx — so the extra order/search calls only
// fire when a user actually downloads. Same look as the old ExcelGenerator button.
export default function DelayMisDownloadButton({ rows = [], baseColumns = [], filename = 'Delayed Shipments', addrMap, label = 'Download' }) {
  const [loading, setLoading] = useState(false);
  const onClick = async () => {
    if (loading || !rows.length) return;
    setLoading(true);
    try {
      // addrMap is the map the grid already loaded — passed through so the MIS doesn't refetch.
      await downloadDelayMis({ rows, baseColumns, filename, addrMap });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button
      onClick={onClick}
      disabled={loading || !rows.length}
      size="small"
      sx={{ fontSize: 11, color: '#000', backgroundColor: '#eee', borderRadius: '5px', px: 1 }}
      startIcon={loading ? <CircularProgress size={14} sx={{ color: '#000' }} /> : <GetAppIcon fontSize="small" sx={{ color: '#000' }} />}
    >
      {loading ? 'Preparing…' : label}
    </Button>
  );
}
